(function () {
  window.addEventListener('load', function () {
    var listeners = [];
    if (!window.inface) window.inface = {};
    if (!window.inface.toyWebSdk) window.inface.toyWebSdk = {};
    window.inface.toyWebSdk.addEventListener = function (callback) {
      if (!listeners.some(function (listener) {
        return callback === listener;
      })) {
        listeners.push(callback);
      }
    };
    window.inface.toyWebSdk.removeEventListener = function (callback) {
      var matched = listeners.indexOf(callback);
      if (matched === -1) return;
      listeners.splice(matched, 1);
    };
    window.addEventListener('toy-web-sdk:event', function (event) {
      listeners.forEach(function (callback) {
        if (typeof callback === 'function') callback(event);
      });
    });
    if (typeof window.onPreparingToyWebSdk === 'function') {
      window.onPreparingToyWebSdk();
    }
  });
})();